import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import AutomaticDiscountForm from '@/components/v2/AutomaticDiscountForm.vue';
import automaticDiscountCreate from '@/plugins/graphql/mutations/v2/automatic-discount-create.gql';
import AutomaticDiscounts from '@/plugins/graphql/queries/v2/automatic-discounts.gql';
import AutomaticDiscountMixin from '@/helpers/vue_mixins/v2/ecommerce/AutomaticDiscountMixin';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
let AutomaticDiscountCreate = class AutomaticDiscountCreate extends Mixins(AlertMixin, RouterParamsAppMixin, AutomaticDiscountMixin, PaginatorMixin, CleverTapEventsMixin) {
    async onSubmit(form) {
        this.mutationRequestOnFlight();
        await this.create(form)
            .then(() => {
            const msg = successfulCreate('Automatic Discount');
            this.voucherAction('SUBMIT CREATE');
            this.successNotification(msg);
            this.goToAutomaticDiscountsPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async create(form) {
        const appUuid = this.appUUID;
        const { name, value, active } = form;
        return this.$apollo.mutate({
            mutation: automaticDiscountCreate,
            variables: {
                input: {
                    name,
                    value,
                    usageLimit: Number(form.usageLimit),
                    startAt: new Date(`${form.startAt}T${form.startAtTime}`),
                    endAt: new Date(`${form.endAt}T${form.endAtTime}`),
                    active,
                    appUuid,
                    discountType: form.discountType,
                    oneTime: form.oneTime,
                },
            },
            update(cache, { data }) {
                const queryOptions = {
                    query: AutomaticDiscounts,
                    variables: {
                        appUuid,
                        first: this.perPage,
                        after: null,
                    },
                };
                const { fetchAllAutomaticDiscounts } = cache.readQuery({
                    ...queryOptions,
                });
                if (!fetchAllAutomaticDiscounts) {
                    return;
                }
                const cachedAutomaticDiscounts = {
                    ...fetchAllAutomaticDiscounts,
                };
                cachedAutomaticDiscounts.edges.unshift({
                    node: data.automaticDiscountAdd.automaticDiscount,
                    __typename: 'AutomaticDiscountEdges',
                });
                cache.writeQuery({
                    ...queryOptions,
                    data: {
                        fetchAllAutomaticDiscounts: cachedAutomaticDiscounts,
                    },
                });
            },
        });
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
    async mounted() {
        await this.$nextTick();
        if (this.isInsuranceBundle) {
            this.$router.push({ name: 'insurance-overview' });
        }
    }
};
AutomaticDiscountCreate = __decorate([
    Component({
        components: {
            PageTitle,
            AutomaticDiscountForm,
        },
    })
], AutomaticDiscountCreate);
export default AutomaticDiscountCreate;
